module.exports = __webpack_public_path__ + "img/standardTitle.aa54c7ec.png";